import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StripePayment } from '../models/stripePayment';
import {ApiService} from './api.service';

@Injectable()
export class StripePaymentService {

    stripeLink = environment.stripeLink;

    apiService: ApiService = new ApiService(this.http);

    constructor(
      private http: Http
    ) { }

    // GET : All Stripe Payment
    getStripePayments(orgId: string): Observable<StripePayment[]> {
        return this.apiService.getCall('stripeLink' , `organizations/${orgId}/transactions`);
    }

	  getStripePaymentsByUserId(orgId: string, userId: string): Observable<StripePayment[]> {
        // return this.apiService.getCall('stripeLink' , `organizations/${orgId}/users/${userId}/transactions`);
        return this.apiService.getCall('stripeLink' , `users/${userId}/transactions`);
    }

    getStripePaymentsByCaseId(orgId: string, caseId: string): Observable<StripePayment[]> {
      // return this.apiService.getCall('stripeLink' , `organizations/${orgId}/cases/${caseId}/transactions`);
      return this.apiService.getCall('stripeLink' , `cases/${caseId}/transactions`);
  }

    postStripePayment(orgId: string, userId: string, stripeToken, amount, mode){
        let data = {
            amount: amount,
            mode:  mode
        };
        if(stripeToken != '') {
          data["token"] = stripeToken;
        }

        return this.apiService.postCall('stripeLink' , `organizations/${orgId}/users/${userId}/transactions`, data);
    }

    // this is to update the stripe payment after the case is made
    updateStripePayment(transactionId: string, caseId: string, data: any){
        return this.apiService.putCall( 'stripeLink' , `transactions/${transactionId}/cases/${caseId}`, data);
    }

    postStripeConnect(code, orgId){
      return this.apiService.postCall('stripeLink' , `organizations/${orgId}/connect?code=${code}`, '{}');
    }

    getStripeConnect(org){
      return this.apiService.getCall('stripeLink' , `organizations/${org}/accounts`);
    }

    postStripeAchMicroDepositVerify(data: any){
      return this.apiService.postCall('stripeLink', `ach/verify`, data);
    }

    getStripePaymentsByCaseIds(caseIds: string): Observable<StripePayment[]> {
      return this.apiService.getCall('stripeLink' , `transactions?caseIds=`+caseIds);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/stripePayment.service.ts